<template>
  <BethsLayout :layoutTitle="`Terms of Use`" :hasBuilding="false">
    <h1>
      Terms of Use <br />
      <small> For AK SafetyNet</small>
    </h1>

    <ol class="list-decimal p-4">
      <li class="my-4">
        <u><strong>License and Terms.</strong></u>
        By accessing this web site, using your AK SafetyNet Subscription or using the
        SafetyNet Respond App, you agree to be bound by all of the terms and conditions of
        these Terms of Use. These Terms of Use are a legal agreement between AK
        PRODUCTIONS, LLC (“AK”, “we” or “us”) and you, as an individual end user (“User”
        or “you”). These Terms of Use governs your access to and use of your AK SafetyNet
        Subscription or the SafetyNet Respond App (each, a “Product”) and
        clients.aksafetynet.com (the “Website”), including any content, functionality or
        services offered on or through any of them, whether as a guest or a registered
        User. Please read these Terms of Use carefully before you start to use the Website
        or a Product. By using the Website or a Product or by clicking to accept or agree
        to the Terms of Use when this option is made available to you, you accept and
        agree to be bound and abide by these Terms of Use and our Privacy Policy, found at
        clients.aksafetynet.com, incorporated herein by reference. If you do not want to
        agree to these Terms of Use or the Privacy Policy, you must not access or use the
        Website or a Product. The Website and each Product is offered and available to
        users who are 13 years of age or older, and reside in the United States or any of
        its territories or possessions. By using the Website or a Product, you represent
        and warrant that you are of legal age to form a binding contract with AK and meet
        all of the foregoing eligibility requirements. If you do not meet all of these
        requirements, you must not access or use the Website or a Product.
        <br />
      </li>
      <li class="my-4">
        <u><strong>Product. </strong></u>
        Each Product includes computer software and any associated video, media, printed
        materials, plans, diagrams, brochures or other related products including “online”
        or electronic materials, and any reference to the term Product shall include such
        items.
        <br />
      </li>
      <li class="my-4">
        <u><strong>Updates. </strong></u>
        We may revise and update these Terms of Use from time to time in our sole
        discretion. All changes are effective immediately when we post them and apply to
        all access to and use of the Website and a Product thereafter. However, any
        changes to the dispute resolution provisions set forth in the Section title
        “General” will not apply to any disputes for which the parties have actual notice
        on or prior to the date the change is posted on the Website or delivered as an
        update to a Product. AK shall have the right at any time to change or discontinue
        any aspect or feature of Product, including, but not limited to, content, hours of
        availability, and equipment needed for access or use. AK shall have the right at
        any time to change or modify the terms and conditions applicable to your use of
        Product, or any part thereof, or to impose new conditions. Your continued use of
        the Website or a Product following the posting of revised Terms of Use means that
        you accept and agree to the changes. You are expected to check this page
        periodically so you are aware of any changes, as they are binding on you.
        <br />
      </li>
      <li class="my-4">
        <u><strong>Accessing the Website and Account Security.</strong></u>

        We reserve the right to withdraw or amend the Website, and any service or material
        we provide on the Website, in our sole discretion without notice. We will not be
        liable if for any reason all or any part of the Website or a Product is
        unavailable at any time or for any period. From time to time, we may restrict
        access to some parts of the Website, a Product, the entire Website or an entire
        Product to Users, including registered Users.
        <br />
      </li>
      <li class="my-4">
        <u><strong>Grant of License. </strong></u>
        <br />
        This Agreement grants you a non-exclusive, non-transferable license to use the
        Website or a Product on the terms and conditions hereof. Any other use of the
        Website or a Product by any person, business, corporation, government organization
        or any other entity is strictly forbidden and is a violation of this Agreement.
        The right to use the Website or a Product is personal to you and is not
        transferable to any other person or entity. You shall be responsible for
        protecting the confidentiality of your password(s). You may not reproduce and
        distribute copies of a Product or any content included with a Product. You have no
        ownership rights or interest in the Website or a Product. The Website and each
        Product and their entire contents, features and functionality (including but not
        limited to all information, software, text, displays, images, video and audio, and
        the design, selection and arrangement thereof) are owned by AK, its licensors or
        other providers of such material and are protected by United States and
        international copyright, trademark, patent, trade secret and other intellectual
        property or proprietary rights laws. You agree that you will not (i) copy, sell,
        market, lend, rent, lease or sublicense a Product to any third party except as
        agreed upon in writing by AK and you, (ii) remove, modify or tamper with a Product
        (or any component or subsystem of a Product), copyrights, branding or trademark
        notifications displayed on a Product, (iii) modify, reuse, disassemble, decompile,
        reverse engineer or otherwise translate functionality contained in, or create
        derivative works of, a Product or any portion thereof or attempt to create the
        source code from the object code for a Product, (iv) import, host, enter into or
        use with a Product any data, software, documents, information, files, links or
        other materials or take any actions that would have the effect of disabling,
        damaging, erasing, delaying, shutting down or otherwise interfering with any of
        AK’s hardware, software, systems or data, (v) use a Product for any purpose that
        is prohibited by local, state, federal or international law, regulation or
        ordinance or these Terms of Use, (vi) import, host, enter into or use with a
        Product any data, language, information, files links, photographs or other
        material that is (a) defamatory, abusive, harassing or racist or (b)
        inappropriate, profane, obscene, indecent or sexually explicit, or (vii) host,
        import, enter into or use with a Product any material if such hosting, importing,
        entering or use would violate copyright, trademark, trade secret or any other
        proprietary rights of any third party.
      </li>
      <li class="my-4">
        <u><strong>Content. </strong></u>
        <br />
        The content provided on the Website and in the Products is for general information
        purposes only and is in no way intended to be a substitute for detailed fire and
        life safety training and planning with qualified professionals and building
        management and thorough site-specific training and drills. Users still need to
        participate in regular drills and understand the special conditions of your
        building or facility, including but not limited to location of stairwells, safety
        systems and equipment, elevator usage guidelines, existence and roles of emergency
        floor teams and where to reassemble during a building evacuation. You also need to
        be aware of planning for responses to local threats (tornados, hurricane,
        earthquake, flooding, etc.). If you are unsure about any issues related to fire or
        life safety, you need to consult with your supervisor, warden, team, or property
        management, as appropriate. Although we review our content, we do not guarantee or
        take responsibility for the accuracy of the content we provide, nor does AK assume
        any liability for the content of web sites linked to our site. Reference to or
        reproduction of specific plans, designs, products, processes or services does not
        constitute or imply recommendation or endorsement by AK. AK also takes no
        responsibility for the emergency training, planning or related resources that
        Account Managers may post to the Website or include in a Product. These materials
        are provided for information purposes only.
      </li>
      <li class="my-4">
        <u><strong>Disclaimer of Warranty. </strong></u>You agree as follows:<br />
        <ol class="list-decimal pl-8">
          <li>
            YOU EXPRESSLY AGREE THAT THE USE OF THE WEBSITE AND EACH PRODUCT IS AT YOUR
            SOLE RISK. NEITHER AK, ITS AFFILIATES NOR ANY OF THEIR RESPECTIVE EMPLOYEES,
            AGENTS, THIRD-PARTY CONTENT PROVIDERS OR LICENSORS WARRANT THAT THE WEBSITE OR
            A PRODUCT WILL BE UNINTERRUPTED OR ERROR FREE, THAT DEFECTS WILL BE CORRECTED,
            THAT OUR SITE, A PRODUCT OR THE SERVER THAT MAKES THEM AVAILABLE ARE FREE OF
            VIRUSES, MALWARE OR OTHER HARMFUL COMPONENTS, NOR DO THEY MAKE ANY WARRANTY AS
            TO THE RESULTS THAT MAY BE OBTAINED FROM USE OF ANY PRODUCT, OR AS TO THE
            ACCURACY, RELIABILITY OR CONTENT OF ANY INFORMATION, SERVICE, OR MERCHANDISE
            PROVIDED THROUGH ANY PRODUCT.
          </li>
          <li>
            THE WEBSITE AND EACH PRODUCT IS PROVIDED ON AN "AS IS" BASIS WITHOUT
            WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
            TO, WARRANTIES OF TITLE OR IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS
            FOR A PARTICULAR PURPOSE, OTHER THAN THOSE WARRANTIES WHICH ARE IMPLIED BY AND
            INCAPABLE OF EXCLUSION, RESTRICTION OR MODIFICATION UNDER THE LAWS APPLICABLE
            TO THESE TERMS OF USE.
          </li>
          <li>
            IN NO EVENT WILL AK, OR ANY PERSON OR ENTITY INVOLVED IN CREATING, PRODUCING
            OR DISTRIBUTING THE WEBSITE OR A PRODUCT, BE LIABLE FOR ANY DAMAGES,
            INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
            CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF THE USE OF OR INABILITY TO
            USE THE WEBSITE OR A PRODUCT. YOU HEREBY ACKNOWLEDGE THAT THE PROVISIONS OF
            THIS SECTION SHALL APPLY TO ALL CONTENT OF THE WEBSITE AND A PRODUCT.
          </li>
          <li>
            AK DOES NOT GUARANTEE THE ACCURACY, COMPLETENESS, OR USEFULNESS OF ANY CONTENT
            CONTAINED IN THE WEBSITE OR A PRODUCT, NOR ITS MERCHANTABILITY OR FITNESS FOR
            ANY PARTICULAR PURPOSE. AK NEITHER ENDORSES NOR IS RESPONSIBLE FOR THE
            ACCURACY OR RELIABILITY OF ANY INFORMATION, OPINION, ADVICE OR STATEMENTS THAT
            ARE PART OF THE WEBSITE OR A PRODUCT. AK NEITHER ENDORSES NOR IS RESPONSIBLE
            FOR THE CONTENT OF ANY “LINKED” THIRD-PARTY WEB SITES OR OTHER SOURCES
            ACCESSED THROUGH THE WEBSITE OR A PRODUCT, AND HAS PROVIDED SUCH LINKS FOR
            INFORMATION PURPOSES ONLY. UNDER NO CIRCUMSTANCES WILL AK BE LIABLE FOR ANY
            LOSS OR DAMAGE CAUSED BY A USER’S RELIANCE ON INFORMATION OBTAINED THROUGH THE
            WEBSITE OR A PRODUCT. IT IS THE RESPONSIBILITY OF USER TO CONSULT WITH FIRE
            AND LIFE SAFETY PROFESSIONALS TO EVALUATE THE ACCURACY, COMPLETENESS OR
            USEFULNESS OF ANY INFORMATION, OPINION, ADVICE OR OTHER CONTENT AVAILABLE
            THROUGH THE WEBSITE OR A PRODUCT.
          </li>
          <li>
            We rely heavily on Amazon Web Services (“AWS”) to operate certain aspects of
            the Website and the Product and any disruption of or interference with our use
            of AWS could impair our ability to operate or maintain the Website or a
            Product. To the extent there is an outage, damage or interruption to AWS, the
            Website and the Product may cease to function, including by failing to
            deliver, or timely deliver, messages, notifications or updates, whether
            related to an emergency or otherwise. ACCORDINGLY, AK IS NOT RESPONSIBLE FOR
            ANY WEBSITE OR PRODUCT DELAY OR FAILURE TO FUNCTION DUE TO UNFORESEEN
            CIRCUMSTANCES OR CAUSES BEYOND ITS REASONABLE CONTROL, INCLUDING ANY
            DISRUPTIONS, INTERRUPTIONS OR INTERFERENCE RELATING TO AWS OR OTHER DELIVERY
            INFRASTRUCTURE.
          </li>
        </ol>
        <br />
      </li>
      <li class="my-4">
        <u><strong>Government End Users. </strong></u>
        <br />
        If you are acquiring the Product on behalf of any unit or agency of the United
        States Government, the Government’s rights in the Product and its documentation
        will be as defined in Clause 52.227-19(c)(2) of the FAR or, in the case of NASA,
        in Clause 18-52.227-86(d) of the NASA Supplement to the FAR.
      </li>
      <li class="my-4">
        <u><strong>Indemnification. </strong></u>
        <br />
        You agree to defend, indemnify and hold harmless AK, its members, managers,
        affiliates, licensors and service providers, and its and their respective
        officers, directors, employees, contractors, agents, licensors, suppliers,
        successors and assigns from and against any claims, liabilities, damages,
        judgments, awards, losses, costs, expenses or fees (including reasonable
        attorneys’ fees) arising out of or relating to your violation of these Terms of
        Use or your use of the Website or a Product, including, but not limited to, any
        use of the Website’s or a Product’s content, services and products other than as
        expressly authorized in these Terms of Use or your use of any information obtained
        from the Website or a Product.
      </li>
      <li class="my-4">
        <u><strong>General. </strong></u>
        <br />
        These Terms of Use shall be construed, interpreted and governed by the laws of the
        State of Washington without regard to conflicts of law provisions thereof. The
        exclusive forum for any disputes arising out of or relating to these Terms of Use
        shall be an appropriate federal or state court sitting in King County, Washington.
        These Terms of Use and our Privacy Policy shall constitute the entire agreement
        between the parties hereto. If any part of these Terms of Use is found invalid or
        unenforceable by a court of competent jurisdiction, the remainder of this
        Agreement shall be interpreted so as to reasonably effect the intention of the
        parties. The owner of the Website and the Products is based in the state of
        Washington in the United States. We provide this Website for use only by persons
        located in the United States. We make no claims that the Website or any of its
        content is accessible or appropriate outside of the United States. Access to the
        Website may not be legal by certain persons or in certain countries. If you access
        the Website from outside the United States, you do so on your own initiative and
        are responsible for compliance with local laws.
      </li>
    </ol>
    <br />

    <p class="my-4">
      <strong
        >ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING TO THESE
        TERMS OF USE, THE WEBSITE OR A PRODUCT MUST BE COMMENCED WITHIN ONE YEAR AFTER THE
        CAUSE OF ACTION ACCRUES, OTHERWISE, SUCH CAUSE OF ACTION OR CLAIM IS PERMANENTLY
        BARRED.</strong
      >
    </p>
    <p class="my-4">
      <strong
        >PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THE WEBSITE OR A PRODUCT.
        BY USING THE WEBSITE OR A PRODUCT, YOU ARE AGREEING TO BE BOUND BY THE TERMS OF
        THIS AGREEMENT.
      </strong>
    </p>
    <p class="my-4">
      All feedback, comments, requests for technical support and other communications
      relating to the Website or a Product should be directed to:
      <a href="mailto:info@akpreparedness.com">info@akpreparedness.com</a>.
    </p>
  </BethsLayout>
</template>
